import axios from "axios"
import { API_BASE_URL } from "../config"

export const manageAccountCatvUpdate = async (
  id: string,
  name: string,
  mail: string,
  auth_account: number,
  auth_list: number,
  auth_setting: number,
  auth_logo: number
) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/account/update`, {
        session_code: localStorage.getItem("session_code"),
        id: id,
        name: name,
        mail: mail,
        auth_account: auth_account,
        auth_list: auth_list,
        auth_setting: auth_setting,
        auth_logo: auth_logo
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
